import { PageQuery } from '../common';
import { HcaStepId, HcaStepResponse } from '../hca_library';

export type GlossaryId = string;
export type GlossaryDefinitionId = string;

export interface CompactGlossaryResponse {
  id: GlossaryId;
  title: string;
  extraWords: string;
}
export interface GlossaryResponse extends CompactGlossaryResponse {
  definitions: GlossaryDefinitionResponse[];
  caseSensitive: boolean;
  steps: HcaStepResponse[];
  linkedHcaSteps: HcaStepResponse[];
  linkedSteps: GlossaryStepResponse[];
}

export interface GlossaryRequest {
  title: string;
  definitions: GlossaryDefinitionResponse[];
  caseSensitive: boolean;
}

export interface GlossaryStepResponse {
  stepId: HcaStepId;
  glossaryId: GlossaryId;
  definitionId: GlossaryDefinitionId;
  linkedWord: boolean;
  definitionWord: string;
  definition: string;
}

export interface GlossaryDefinitionResponse {
  language: GlossaryLanguages;
  body: string;
  id: string;
}

export interface GlossaryPageQuery extends PageQuery {
  search?: string;
  sortBy?: string;
  sortDirection?: 'asc' | 'desc';
}

export interface GlossaryStepResponse {
  id: GlossaryId;
  title: string;
  definitions: GlossaryDefinitionResponse[];
  caseSensitive: boolean;
}

export interface GlossaryStepResponse {
  word: string;
  wordId: string;
  definitions: GlossaryDefinitionResponse[];
}

export enum GlossaryLanguages {
  all = 'all',
  english = 'english',
  chinese = 'chinese',
  hungarian = 'hungarian',
  french = 'french',
  russian = 'russian',
  spanish = 'spanish',
  german = 'german',
  italian = 'italian',
  dutch = 'dutch',
  swedish = 'swedish',
  hebrew = 'hebrew',
  slovak = 'slovak',
  japanese = 'japanese',
  czech = 'czech',
  bulgarian = 'bulgarian',
}
